import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "./BuildingFactorForm.css";

const BuildingFactorForm = () => {
  const [form, setForm] = useState({
    buildingUse: "",
    factor: ""
  });

  const [editId, setEditId] = useState(null);

  const [data, setData] = useState([
    { id: 1, buildingUse: "निवासी", factor: 1.0 },
    { id: 2, buildingUse: "औद्योगिक", factor: 1.5 },
    { id: 3, buildingUse: "वाणिज्यक", factor: 1.25 },
  ]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    if (!form.buildingUse || !form.factor) {
      alert("सर्व माहिती भरणे आवश्यक आहे");
      return;
    }
    
    if (editId) {
      // Edit mode - update existing record
      setData(data.map((item) => 
        item.id === editId 
          ? { ...item, buildingUse: form.buildingUse, factor: form.factor }
          : item
      ));
      alert("माहिती सफलतेने अपडेट झाली! ✅");
      setEditId(null);
    } else {
      // Add new record
      setData([...data, { id: Date.now(), buildingUse: form.buildingUse, factor: form.factor }]);
      alert("माहिती यशस्वीरित्या जतन झाली! ✅");
    }
    
    setForm({ buildingUse: "", factor: "" });
  };

  const handleReset = () => {
    setForm({ buildingUse: "", factor: "" });
    setEditId(null);
  };

  const deleteData = (id) => {
    if (window.confirm("हटवायचं आहे का?")) {
      setData(data.filter((item) => item.id !== id));
      if (editId === id) {
        setEditId(null);
        setForm({ buildingUse: "", factor: "" });
      }
    }
  };

  const editData = (item) => {
    setForm({ buildingUse: item.buildingUse, factor: item.factor });
    setEditId(item.id);
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      
      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("इमारत भारांक दर", pageWidth / 2, 10, { align: "center" });
      
      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);
      
      const exportData = specificId 
        ? data.filter(item => item.id === specificId)
        : data;
      
      const tableData = exportData.map((item, index) => [
        index + 1,
        item.buildingUse,
        item.factor
      ]);
      
      pdf.autoTable({
        head: [["अ.क्र.", "इमारत वापर", "भारांक"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 11
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });
      
      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(`पृष्ठ ${i} / ${pageCount}`, pageWidth / 2, pdf.internal.pageSize.getHeight() - 10, { align: "center" });
      }
      
      const fileName = specificId ? `भारांक-दर-${specificId}.pdf` : `भारांक-दर-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  return (
    <div className="building-factor-container">
      <div className="header">इमारत भारांक दर</div>

      <div className="wrapper">
        <div className="box">
          {editId && (
            <div className="edit-mode-banner">
              ✏️ संपादन मोड (ID: {editId})
            </div>
          )}
          <div className="form-row">
            <div className="field">
              <label>
                इमारत वापर <span className="required">*</span>
              </label>
              <select
                name="buildingUse"
                value={form.buildingUse}
                onChange={handleChange}
              >
                <option value="">-- निवडा --</option>
                <option value="निवासी">निवासी</option>
                <option value="औद्योगिक">औद्योगिक</option>
                <option value="वाणिज्यक">वाणिज्यक</option>
              </select>
            </div>

            <div className="field">
              <label>
                भारांक <span className="required">*</span>
              </label>
              <input
                type="number"
                step="0.01"
                name="factor"
                value={form.factor}
                onChange={handleChange}
                placeholder="उदा. 1.5"
              />
            </div>
          </div>

          <div className="btn-area">
            <button className="btn btn-save" onClick={handleSubmit}>
              जतन करा
            </button>
            <button className="btn btn-reset" onClick={handleReset}>
              रीसेट करा
            </button>
          </div>
        </div>
      </div>

      {/* Data Table */}
      <div className="table-container">
        <div className="table-header">
          <h3 className="table-title">भारांक दर यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
            {data.length > 0 && (
              <button className="btn-pdf-specific" onClick={() => {
                if (editId) {
                  generatePDF(editId);
                } else {
                  alert("कृपया संपादित करायचा रेकॉर्ड निवडा");
                }
              }}>
                📋 विशिष्ट PDF
              </button>
            )}
          </div>
        </div>
        <table className="data-table">
          <thead>
            <tr>
              <th>अ.क्र.</th>
              <th>इमारत वापर</th>
              <th>भारांक</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((item, index) => (
                <tr key={item.id} className={editId === item.id ? "edit-row" : ""}>
                  <td>{index + 1}</td>
                  <td>{item.buildingUse}</td>
                  <td>{item.factor}</td>
                  <td className="action-btns">
                    <button 
                      className="btn-edit"
                      onClick={() => editData(item)}
                    >
                      Edit
                    </button>
                    <button 
                      className="btn-delete"
                      onClick={() => deleteData(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="no-data">कोणती माहिती उपलब्ध नाही</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BuildingFactorForm;
